import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../../config/apiConfig";

export const useDashboardData = () => {
  const [imei, setImei] = useState("");
  const [mobile, setMobile] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [mobileSearchCertificate, setMobileSearchCertificate] = useState([]);
  // Track whether a search attempt was made
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClose = () => {
    setShowError(false);
  };

  const validateMobile = (mobile) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobile);
  };
  const validateIMEI = (imei) => {
    const regex = /^\d{15}$/;
    return regex.test(imei);
  };

  const getCertificateByImeiApi = () => {
    if (!imei) {
      toast.error("Please enter IMEI to search.");
      return;
    }
    if (!validateIMEI(imei)) {
      toast.error("Invalid IMEI. Enter exactly 15 digits.");
      return;
    }
    setIsLoading(true);
    setHasSearched(true);
    setMobileSearchCertificate([]);
    axios({
      method: "GET",
      url: `${API_URL.GET_CERTIFICATE_BY_IMEI_OR_MOBILE(imei, "")}`,
    })
      .then((res) => {
        if (res?.status === 200) {
          setSearchData(res?.data || []);
          if (!res?.data || res?.data?.length === 0) {
            toast.error("No Certificate found for this IMEI number.");
          }
        } else {
          setSearchData([]);
          setErrorMessage("*No Certificate found for this IMEI number.");
          setShowError(true);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setSearchData([]);
        setIsLoading(false);
      });
  };

  const getCertificateListApi = async () => {
    if (!mobile) {
      toast.error("Please enter Mobile Number to search.");
      return;
    }
    if (!validateMobile(mobile)) {
      toast.error("Invalid Mobile Number. Enter 10 digits (starting 6-9).");
      return;
    }
    setIsLoading(true);
    setHasSearched(true);
    setSearchData([]);
    axios(`${API_URL.GET_CERTIFICATE_BY_IMEI_OR_MOBILE("", mobile)}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (res?.status === 200) {
          setMobileSearchCertificate(res?.data || []);
          if (!res?.data || res?.data?.length === 0) {
            toast.error("No Certificate found for this Mobile number.");
          } else if (res?.data?.message) {
            toast.success(res?.data?.message);
          }
        } else {
          setMobileSearchCertificate([]);
          toast.error(res?.data?.message || "No Certificate found.");
        }
        setIsLoading(false);
      })
      .catch(() => {
        setMobileSearchCertificate([]);
        setIsLoading(false);
      });
  };

  const handleViewDetails = (item = {}) => {
    setSelectedRow(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
  };

  return {
    mobile,
    setMobile,
    imei,
    setImei,
    getCertificateListApi,
    getCertificateByImeiApi,
    mobileSearchCertificate,
    setMobileSearchCertificate,
    searchData,
    setSearchData,
    hasSearched,
    setHasSearched,
    isLoading,
    showError,
    handleClose,
    errorMessage,
    handleViewDetails,
    selectedRow,
    isModalOpen,
    handleCloseModal,
  };
};
